/**Removes null, undefined, NaN and empty string key/value pairs from the object */
export const removeEmptyKeys = (obj: Record<string, any>) => {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      if (value !== null && value !== undefined && !Number.isNaN(value) && value !== '') {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, any>,
  );
};

/**Get partial object of specified `keys` */
export function pluck<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  const ret: any = {};
  for (let key of keys) {
    ret[key] = obj[key];
  }
  return ret;
}
